const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-support-form'] = {
        c: () => require('partner/modules/cus-support-form/cus-support-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-support-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-support-form'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };